import {Injectable} from "@angular/core";

declare var window: Window;

/**
 * window function
 */
function getWindow(): Window {
    return window;
}

/**
 * Global Window Ref service
 */
@Injectable()
export class NgWindowRefService {
    constructor() {}

    get nativeWindow(): Window {
        return getWindow();
    }
}
